export default {
	forms: {
		edit: {
			config: {
				fields: {
					id: {
						config: {
							hide: true
						}
					},
					code: {},
					name: {}
				}
			}
		},
		list: {
			config: {
				fields: {
					id: {
						config: {
							hide: true
						}
					},
					code: {},
					name: {}
				}
			}
		},
		select: {
			panel: {
				width: '80%'
			},
			config: {
				fields: {
					id: {
						config: {
							hide: true
						}
					},
					code: {},
					name: {}
				}
			}
		}
	}
}